<template>
  <div id="Dypassword" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1" :class="!$route.query.install_code ? 'color-primary' : 'color-white'"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span>utorización</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt10 pb10 pl20 pr20 color-muted" v-if="password == ''">
      No ha habilitado la función de contraseña dinámica. Ingrese la contraseña del usuario local para vincular la cuenta.
    </div>
    <div class="col-12 t-c p30 bg-color-white h16" v-if="password">
      <barcode v-bind:value="password" width="4" :displayValue="displayValue" fontSize="24">
        000 000
      </barcode>
    </div>
    <div class="col-12 t-c p20 bg-color-white" v-if="password">
      <qrcode-vue :value="password" :size="300" level="H" />
    </div>
    <div class="col-12 t-c pt10 pb10 bg-color-white" v-if="password">
      <div class="col-12"><span class="fw">Contraseña dinámica</span></div>
      <div class="col-12 mt10" @click="show_password()">
        <span class="f34 fw" v-if="password == ''">*** ***</span>
        <span class="f30 fw" v-else>{{password_show}} </span>
        <span><i class="iconfont icon-yincang f28 color-muted" v-if="password_show != '*** ***'"></i> <i class="iconfont icon-yanjing f28 color-muted" v-else></i></span>
      </div>
    </div>
    <div class="col-12 t-c pt30" v-if="password == ''">
      <input type="text" class="bg-color-white h4 b-s-2 r5 pl5 pr5 w20 fw uppercase" placeholder="Clave" v-model="user_password">
      <input type="button" value="Confirmar" class="b1 h4 pl5 pr5 r5 f14" @click="bind_user()" :disabled="!user_password.length" :class="[user_password.length?'bg-color-primary color-white':'color-muted']">
    </div>
    <div class="h5"></div>
  </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue'
import VueBarcode from 'vue-barcode';
export default {
  name: 'Dypassword',
  data () {
    return {
      user_password: '',
      password: '000 000',
      password_show: '*** ***',
      displayValue: false,
      user_id: '',
    }
  },
  created: function () {
    this.get_dynamic_password();
  },
  methods: {
    //获取动态密码
    get_dynamic_password() {
      var post_data = {}
      this.post(this.api_url + 'manage/dynamic_password',post_data,true).then((res)=>{
        console.log(res)
        if(res.status == 1){
          this.password = res.data.dynamic_password;
        }else{
          this.password = ''
        }
      })
    },
    //绑定用户
    bind_user() {
      var post_data = {}
      post_data.user_password = this.user_password
      this.post(this.api_url + 'manage/bind_user',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_dynamic_password();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //显示/隐藏密码
    show_password() {
      if(this.password_show == '*** ***'){
        this.displayValue = true;
        this.password_show = this.password.replace(/(.{3})/g, "$1 ");
      }else{
        this.displayValue = false;
        this.password_show = '*** ***';
      }
    }
  },
  watch: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  components: {
    QrcodeVue,
    'barcode': VueBarcode
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Fun/Dypassword.vue